import { REMOVE_HIGHLIGHT_COLOR } from '@atlaskit/editor-common/ui-color';

export const isMac =
  typeof navigator !== 'undefined' && /Mac|iPod|iPhone|iPad/.test(navigator.userAgent);

export const noop = () => {};

export const TEXT_COLOR_PALETTE_COLS = 7;

export const POPUP_MENU_GROUP_WIDTH = 225;

export function getHighlightPaletteColors(palette: unknown): string[] {
  if (!palette) {
    return [];
  }
  if (Array.isArray(palette)) {
    const colors: string[] = [];
    for (const item of palette.flat()) {
      if (typeof item === 'string' && item !== REMOVE_HIGHLIGHT_COLOR) {
        colors.push(item);
      } else if (
        item &&
        typeof item === 'object' &&
        'value' in item &&
        typeof (item as { value: string }).value === 'string'
      ) {
        const val = (item as { value: string }).value;
        if (val !== REMOVE_HIGHLIGHT_COLOR) {
          colors.push(val);
        }
      }
    }
    return colors;
  }
  if (typeof palette === 'object' && palette !== null && 'palette' in palette) {
    return getHighlightPaletteColors((palette as { palette: unknown }).palette);
  }
  return [];
}
